import { CloseOutlined, MenuOutlined } from '@ant-design/icons';
import { Divider, Drawer, Row, Space, Typography } from 'antd';
import Cookies from 'js-cookie';
import { useState } from 'react';
import { useAppSelector } from 'redux/store';
import { MenuItem } from './MenuItem';

export const PhoneNavMenu = () => {
  const customerCookie = Cookies.get(`${process.env.REACT_APP_COOKIE_PREFIX}_acuity_context`);
  const { user, theme } = useAppSelector((state) => state.app);
  const isDarkMode = theme === 'dark';

  // Theme-specific colors
  const textColor = isDarkMode ? '#84859a' : '#595959';
  const bgColor = isDarkMode ? '#1f1e2e' : '#ffffff';
  const borderColor = isDarkMode ? '#2a293b' : '#e8e8e8';

  const isMdsiEmployee = user && user['https://acuity.mdsiinc.com/user/user_metadata'].is_mdsi_employee;
  const [visible, setVisible] = useState(false);
  const items = [
    {
      text: 'Divisions',
      url: customerCookie ? '/divisions' : '/'
    },
    {
      text: 'Applications',
      url: '/divisions'
    },
    {
      text: 'Internal Applications',
      url: '/internal-applications'
    },
    {
      text: 'Warehouse Applications',
      url: '/warehouse-applications'
    },
    {
      text: 'Profile',
      url: '/profile'
    },
    {
      text: 'About',
      url: '/about'
    },
    {
      text: 'Log Out',
      url: '/logout'
    }
  ];

  const filteredItems = items.filter((item) => {
    if (!customerCookie) {
      return item.text !== 'Applications';
    }
    if (!isMdsiEmployee) {
      return item.text !== 'Warehouse Applications' && item.text !== 'Internal Applications';
    }
    return true;
  });

  return (
    <>
      <MenuOutlined style={{ fontSize: 25, color: textColor, cursor: 'pointer' }} onClick={() => setVisible(true)} />
      <Drawer
        title={
          <Row justify="space-between" align="middle" style={{ padding: '8px 0' }}>
            <Typography.Text style={{ fontSize: '18px', color: textColor }}>Menu</Typography.Text>
            <CloseOutlined style={{ fontSize: 20, color: textColor, cursor: 'pointer' }} onClick={() => setVisible(false)} />
          </Row>
        }
        destroyOnClose
        width={'85%'}
        open={visible}
        closeIcon={null}
        closable
        onClose={() => setVisible(false)}
        style={{ backgroundColor: bgColor }}
        headerStyle={{
          backgroundColor: bgColor,
          borderBottom: `1px solid ${borderColor}`,
          padding: '16px 24px'
        }}
        bodyStyle={{
          backgroundColor: bgColor,
          color: textColor,
          padding: '24px'
        }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          {filteredItems.map((item, index) => (
            <div key={index}>
              <MenuItem text={item.text} url={item.url} setVisible={setVisible} />
              {index < filteredItems.length - 1 && <Divider style={{ margin: '8px 0', borderColor: borderColor }} />}
            </div>
          ))}
        </Space>
      </Drawer>
    </>
  );
};
